function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  transform: "rotate(90 10.5 12.5)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 2,
  y: 1,
  fill: "#21303E",
  rx: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 2,
  r: 1.75,
  fill: "#FFF",
  stroke: "#21303E",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 2,
  y: 8,
  fill: "#21303E",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 2,
  y: 15,
  fill: "#21303E",
  rx: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 9,
  r: 1.75,
  fill: "#FFF",
  stroke: "#21303E",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 16,
  r: 1.75,
  fill: "#FFF",
  stroke: "#21303E",
  strokeWidth: 1.5
}));

function SvgSearchFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21
  }, props), _ref);
}

export default SvgSearchFilter;